/// <reference path='../../../../../common/types/okta.ts' />

import * as React from 'react';
import { useEffect } from 'react';
import OktaSignIn from '@okta/okta-signin-widget';
import './okta-widget-assets/okta-override-styles.scss';
import { ProductContent, SettingsForApp } from '../../apps';

export type ISignInProps = {
  fromUri: string;
  settingsForApp: SettingsForApp;
  productContent: ProductContent;
};

export default function SignIn({fromUri, settingsForApp, productContent}: ISignInProps) {

  useEffect(() => {
    var signIn = new OktaSignIn({
      baseUrl: window.spConfig.oktaBaseUrl,
      i18n: productContent.i18n,
      features: {
        registration: settingsForApp.registrationEnabled
      },
      registration: {
        click: function () {
          window.location.href = '/register' + (fromUri && `?fromURI=${fromUri}`);
        }
      },
      helpLinks: {
        help: settingsForApp.helpLink,
        forgotPassword: '/forgot-password' + (fromUri && `?fromURI=${fromUri}`),
      },
    });

    signIn.renderEl({
      el: '#widget-container'
    }, function success(res: any) {
      if (res.status === 'SUCCESS') {
        res.session.setCookieAndRedirect(fromUri);
      } else {
        // The user can be in another authentication state that requires further action.
        // For more information about these states, see:
        //   https://github.com/okta/okta-signin-widget#rendereloptions-success-error
      }
    });

    // attach a unique class to each page to enable better styling
    signIn.on('afterRender', (context: any) => {
      const parentElem = document.getElementById('widget-container');
      if (parentElem) {
        parentElem.className = `oktapage-${context.controller}`;
      }
    });

    return () => {
      signIn.remove();
    };
  }, []);

  return (
    <div>
      <div id="widget-container"></div>
    </div>
  )
}
